import { render, staticRenderFns } from "./Sidepanel.vue?vue&type=template&id=43b3513c&scoped=true"
import script from "@/views/Webshop/Sidepanel/Sidepanel.ts?vue&type=script&lang=ts&external"
export * from "@/views/Webshop/Sidepanel/Sidepanel.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Webshop/Sidepanel/sidepanel.scss?vue&type=style&index=0&id=43b3513c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3513c",
  null
  
)

export default component.exports